<template>
<ContentWrapper>
    <div class="content-heading">
      <div>금칙어 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          게시물 관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/community/badWordList">금칙어 관리</a>
        </li>
      </ol>
    </div>
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="search"/>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" style="width:100%"/>
          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">금칙어 추가등록</label>
            </div>
            <div class="col-auto">
              <input type="text" v-model="data.params.badWord" @keyup.enter="addBadWord()" 
                  :class="{' form-control':true, 'is-invalid': errors.has('badWord')}"
                  style="width:300px" v-validate="'required'" name="badWord">
            </div>
            <div class="col-auto">
                <button @click="addBadWord()" class="btn btn-danger mr-2">등록</button>
                <button @click="downloadTemplate()" class="btn btn-primary ">양식 다운로드</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        
        <span class="text-bold h4">목록</span>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
        <div class="form-group no-margin row" style="width:100%">
          <div class="col-3">
          </div>
          <div class="col-6" style="text-align:center;">
            <button :disabled="!data.enabledApply" @click="updateStatus(true)" class="btn btn-outline-info mr-3">적용</button>
            <button :disabled="!data.enabledDefer" @click="updateStatus(false)" class="btn btn-outline-info mr-3">보류</button>
            <button :disabled="!data.enabledDelete" @click="deleteBadWord()" class="btn btn-outline-info">삭제</button>
          </div>
          <div class="col-3" style="text-align:right;">
            <button @click="addBadWordExcel()" class="btn btn-danger mr-2">엑셀로 등록</button>
            <input v-show="false" ref="fileInput" type="file" @change="readBadWordExcel" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
            <button @click="downloadList()" class="btn btn-primary ">목록 다운로드</button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center"><input type="checkbox" v-model="data.selectAll" /></td>
              <td width="4%" style="text-align:center">No</td>
              <td width="*" style="text-align:center" @click="localSort.sort('word')">금칙어<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="10%" style="text-align:center" @click="localSort.sort('regId')" >등록자<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="10%" style="text-align:center" >적용상태</td>
              <td width="10%" style="text-align:center" @click="localSort.sort('regDt')" >등록일<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="10%" style="text-align:center" >삭제</td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="7">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center"><input type="checkbox" v-model="data.selectedWords" :value="item.seq" /></td>
                <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center">
                  <input type="text" v-model="item.word"
                    @change="updateBadWord(item.seq, item.word)"
                    :class="{' form-control':true, 'is-invalid': errors.has('table_word_' + index)}"
                    v-validate="'required'" :data-vv-name="'table_word_' + index"/>
                </td>
                <td class="align-middle text-center">{{item.regId}}</td>
                <td class="align-middle text-center">{{item.status}}</td>
                <td class="align-middle text-center">{{item.regDt}}</td>
                <td class="align-middle text-center">
                  <button @click="deleteBadWord(item.seq)" class="btn btn-danger">삭제</button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, ValueTexts} from "@/utils/Constants";
import * as badAPI from "@/api/community/CommunityAPI";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import Xlsx from 'xlsx';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {SchDateRange, SchText, ShowCounter, Pagenation, Loading},
    setup(props, {root}) {
      const isTest = false;
      const modalLoading = ref(false);

      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.selectedWords = [];
      _dataObject.selectAll = computed({
        get() {
          return data.list.length ? data.selectedWords.length == data.list.length : false;
        },
        set(newValue) {
          let selected = [];
          if (newValue) {
            data.list.forEach(item => {
              selected.push(item.seq);
            });
          }
          data.selectedWords = selected;
        }
      });
       // disable button
      const enabledButton = () => {
        return data.selectedWords.length > 0;
      }
      const enabledDelete = () => {
        return enabledButton();
      }
      const enabledApply = () => {
        if (!enabledButton()) {
          return false;
        }
        const selectedWords = data.list.filter(item => data.selectedWords.includes(item.seq));
        return selectedWords.some(item => item.status != 'Y');
      }
      const enabledDefer = () => {
        if (!enabledButton()) {
          return false;
        }
        const selectedWords = data.list.filter(item => data.selectedWords.includes(item.seq));
        return selectedWords.some(item => item.status != 'N');
      }
      _dataObject.enabledDelete = computed(enabledDelete);
      _dataObject.enabledApply = computed(enabledApply);
      _dataObject.enabledDefer = computed(enabledDefer);
      const data = reactive(_dataObject);
      data.schOptions = [
        {value:'word', text:'금칙어'},
        {value:'regId', text:'등록자'},
      ]
      
      const retVals = {
        isTest,
        modalLoading,
        data,
        ...methods(props, data),
        dataAction: new TableActionClass(data),
        localSort:root.$_localSort
      }

      onMounted(async () => {
        if (store.state.params.name == 'badWordList') {
          const storedData = store.state.params.data;
          retVals.data.params = storedData.params;
          retVals.data.selectedUserTypes = storedData.userTypes;
          store.commit('setParams', {name:'', data:undefined});
        }
        await retVals.search();
      });

      return retVals;
    }
}

function methods(props, data) {

  // 목록
  async function search(page) {
    console.log('search:', data);

    if (!isNaN(page)) {
      data.params.page = page;
    }

    const result = await badAPI.getBadWordList(data.params, this.isTest);
    data.list = result.data;
    data.count = result.count;
    this.localSort.set(data.list);
  }

  // 금칙어 등록
  async function addBadWord() {
    const isValid = await this.$validator.validate('badWord');
    if (!isValid) {
      alert('필수 입력 항목을 확인해주세요');
      return;
    }
    const params = [{
      word : data.params.badWord,
      status : 'Y'
    }];
    const result = await badAPI.registerBadWord(params, this.isTest);
    alert('등록했습니다.');
    data.params.badWord = '';
    this.search(1);
  }

  // 금칙어 상태 변경
  async function updateStatus(isApply) {
    const confirmStr = isApply ? '선택한 금칙어를 적용하시겠습니까?' : '선택한 금칙어 적용을 보류하시겠습니까?';
    if (!confirm(confirmStr)) {
      return;
    }

    const statusStr = isApply ? 'Y' : 'N';
 
    const updateItemList = data.list.filter(item => item.status != statusStr)
      .filter(item => data.selectedWords.includes(item.seq));

    console.log('updateItemList:', updateItemList);
    if (updateItemList.length == 0) {
      alert(isApply ? '적용할 금칙어가 없습니다.' : '보류할 금칙어가 없습니다.');
      return;
    }

    updateItemList.forEach((item) => item.status = statusStr);
    console.log('update Status List', updateItemList);
    const result = await badAPI.updateStatus(updateItemList, this.isTest);
    if (result.data) {
      alert(isApply ? "적용했습니다." : "보류했습니다.");
      data.selectedWords = [];
      this.search();
    } else if (result.message) {
      alert(result.message);
    }
  }

  // 금칙어 삭제
  async function deleteBadWord(seq) {
    const confirmStr = '선택한 금칙어를 삭제하시겠습니까?';
    if (!confirm(confirmStr)) {
      return;
    }

    let deleteItemList = seq ? [{"seq":seq}] 
      : data.list.filter(item => this.data.selectedWords.includes(item.seq));
    console.log('delete List', deleteItemList);
    if (deleteItemList.length == 0) {
      alert('삭제할 금칙어가 없습니다.');
      return;
    }
    
    const result = await badAPI.deleteBadWord(deleteItemList, this.isTest);
    console.log(result);
    if (result.data) {
      alert('금칙어를 삭제하였습니다.');
      data.selectedWords = [];
      this.search();

    } else if (result.message) {
      alert(result.message);
    }
  }

  // 금칙어 수정
  async function updateBadWord(seq, word) {
    const params = [{
      seq : seq,
      word : word
    }];
    const result = await badAPI.updateBadWord(params, this.isTest);
    alert('수정했습니다.');
  } 

  // 금칙어 엑셀 등록
  async function addBadWordExcel() {
    const fileInput = this.$refs.fileInput;
    fileInput.click();
  }

  async function readBadWordExcel(event) {
    console.log('readBadWordExcel, ', event);

    // get File object from input tag
    const file = event.target.files[0]; 
    if (!file) {
      return;
    }
    const fileName = file.name; 
    const reader = new FileReader(); 

    // if you use "this", don't use "function(e) {...}" 
    reader.onload = async (e) => { 
      let data = e.target.result; 
      data = new Uint8Array(data); 
      // get excel file 
      const excelFile = Xlsx.read(data, { type: "array" });

      if (excelFile.SheetNames.length > 0) {
        const firstSheetName = excelFile.SheetNames[0];
        const firstSheet = excelFile.Sheets[firstSheetName];
        const roa = Xlsx.utils.sheet_to_json(firstSheet, /*{header:1}*/);
        if (roa.length) {
          const addList = roa.map((item) => {
            return {'word':item['등록금칙어'], 'status':item['노출상태']}
          });
          console.log('addList:', addList);
          const result = await badAPI.registerBadWord(addList, this.isTest);
          alert('엑셀로 등록했습니다.');
          this.search(1);
        }
      }
    }; 
    reader.readAsArrayBuffer(file);
  }

  // 금칙어 양식 다운로드
  async function downloadTemplate() {
    const workBook = Xlsx.utils.book_new();
    const exportList = [];
     const displays = ['Y', 'Y', 'Y', 'Y', 'Y','Y', 'Y', 'N', 'N', 'N',
      'Y', 'Y', 'Y', 'N', 'N', 'Y', 'Y', 'Y', 'N', 'N'];
    for (const index in [...Array(20)]) {
      const seq = index * 1 + 1;
      const item = {'등록금칙어':`금칙어${seq}`, '노출상태':`${displays[index]}`};
      exportList.push(item);
    }

    const workSheet = Xlsx.utils.json_to_sheet(exportList);
    Xlsx.utils.book_append_sheet(workBook, workSheet, '금칙어 양식');
    Xlsx.writeFile(workBook, '금칙어-등록양식.xlsx');
  }

  // 전체 목록 다운로드
  async function downloadList() {
    // 전체 목록 가져오기
    const params = _.cloneDeep(data.params);
    params.limit = -1;

    const result = await badAPI.getBadWordList(params, this.isTest);
    const totalList = result.data;

    const workBook = Xlsx.utils.book_new();
    const exportList = totalList.map((item) => { return {'등록금칙어':item.word, '노출상태':item.status} });

    const workSheet = Xlsx.utils.json_to_sheet(exportList);
    Xlsx.utils.book_append_sheet(workBook, workSheet, '금칙어목록');
    const date = moment().format('YYYY-MM-DD');
    Xlsx.writeFile(workBook, `금칙어목록_${date}.xlsx`);
  }

  return {
    search,
    addBadWord,
    updateStatus,
    deleteBadWord,
    updateBadWord,
    addBadWordExcel,
    readBadWordExcel,
    downloadTemplate,
    downloadList
  }
}
</script>